import { useI18n } from 'vue-i18n'
import { PRICES } from '../model/priceBook'
import type { Period } from '../model/spec'

/** Money, percentages and the price date, formatted for the visitor's language. */
export function useFormat() {
  const { n, d } = useI18n()

  return {
    // An hour of a small resource costs fractions of a cent; two decimals would
    // show most of them as $0.00.
    money: (value: number, period: Period = 'month'): string =>
      n(value, {
        style: 'currency',
        currency: PRICES.currency,
        minimumFractionDigits: 2,
        maximumFractionDigits: period === 'hour' ? 4 : 2,
      }),
    // A discount can be 12.5%; a comparison reads better whole.
    percent: (value: number, digits = 1): string =>
      n(value, { style: 'percent', maximumFractionDigits: digits }),
    // A calendar date, not a moment: formatted in UTC so no time zone moves it a day.
    date: (iso: string): string =>
      d(new Date(`${iso}T00:00:00Z`), { dateStyle: 'long', timeZone: 'UTC' }),
  }
}
